export default __webpack_public_path__ + "static/media/ic_tracking_start.7594da6a.svg";